import LandingDiscord from './LandingDiscord';

export function restaurantAppUrl(hostname, query = '') {
  const isRistoDailyDomain = hostname === 'ristodaily.com' || hostname.endsWith('.ristodaily.com');
  return `${isRistoDailyDomain ? 'https://app.ristodaily.com' : ''}/app${query}`;
}

export default function Landing() {
  return <LandingDiscord preview={false} />;
}
